@use "variables" as *;

.input {
  font-size: $fontSize-m;
  font-weight: bold !important;
  height: 40px;
  border-radius: 12px !important;
}
